import { useRecoilValue } from 'recoil';

import LabOrderCreate from 'components/practice/charts/ClinicalNote/Orders/views/LabOrderCreate/LabOrderCreate';
import LabOrderPreview from 'components/practice/charts/ClinicalNote/Orders/views/LabOrderPreview/LabOrderPreview';
import NonERXPrescriptionCreate from 'components/practice/charts/ClinicalNote/Orders/views/NonERXPrescriptionCreate/NonERXPrescriptionCreate';
import NonERXPrescriptionPreview from 'components/practice/charts/ClinicalNote/Orders/views/NonERXPrescriptionPreview/NonERXPrescriptionPreview';
import OrderReferralCreate from 'components/practice/charts/ClinicalNote/Orders/views/OrderReferralCreate/OrderReferralCreate';
import OrderReferralPreview from 'components/practice/charts/ClinicalNote/Orders/views/OrderReferralPreview/OrderReferralPreview';
import OrderTypeSelection from 'components/practice/charts/ClinicalNote/Orders/views/OrderTypeSelection';
import { permissions } from 'components/state';

import DocumentPreview from '../components/DocumentPreview';
import ResultsList from '../components/ResultsList';
import LabSoftOrderCreate from '../views/LabSoftOrderCreate/LabSoftOrderCreate';

const useActionViews = ({ activeView, handleActionProps, setActiveView, handleClose }) => {
  const { is_admin } = useRecoilValue(permissions);

  const onNavigateViews = ({ view = '', overrideObject = {} }) => {
    setActiveView((prevState) =>
      overrideObject ? overrideObject : { ...prevState, component: view }
    );
  };

  const onSelectActionType = (object) => {
    onNavigateViews({
      overrideObject: { ...activeView, type: object?.type, component: 'create' }
    });
  };

  const actionViews = {
    initial: {
      components: {
        list: <OrderTypeSelection onSelect={onSelectActionType} />
      }
    },
    referral_order: {
      components: {
        create: (
          <OrderReferralCreate {...handleActionProps} onSave={() => onNavigateViews('create')} />
        ),
        preview: (
          <OrderReferralPreview {...handleActionProps} onEdit={() => onNavigateViews('preview')} />
        )
      }
    },
    non_erx_prescription: {
      components: {
        create: (
          <NonERXPrescriptionCreate
            {...handleActionProps}
            onSave={() => onNavigateViews('create')}
          />
        ),
        preview: (
          <NonERXPrescriptionPreview
            {...handleActionProps}
            onEdit={() => onNavigateViews('preview')}
          />
        )
      }
    },
    lab_order: {
      components: {
        create: <LabOrderCreate {...handleActionProps} onSave={() => onNavigateViews('create')} />,
        preview: (
          <LabOrderPreview {...handleActionProps} onEdit={() => onNavigateViews('preview')} />
        )
      }
    },
    ...(is_admin && {
      elab_order: {
        components: {
          create: <LabSoftOrderCreate {...handleActionProps} onSave={() => handleClose()} />,
          preview: <LabOrderPreview {...handleActionProps} />
        }
      }
    }),
    results: {
      components: {
        list: <ResultsList {...handleActionProps} />,
        preview: <DocumentPreview {...handleActionProps} />
      }
    }
  };

  return { actionViews };
};

export default useActionViews;
